import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { List, useDataGrid } from "@refinedev/mui";
import { Button, Select } from "@mui/material";
import { useUpdate } from "@refinedev/core";
import React, { useState, useCallback } from "react";
import ShowPhoto from './showPhoto';
import LinkIcon from '@mui/icons-material/Link';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import CloseIcon from '@mui/icons-material/Close';
import { FormControlLabel } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import SearchIcon from '@mui/icons-material/Search';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { SelectChangeEvent } from '@mui/material/Select';
import ReviewStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/reviewStatus";

export const ReviewsList = () => {
    const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
        filters: {
            initial: [
                {
                    field: "status",
                    operator: "eq",
                    value: 1,
                },
            ],
        },
        sorters: {
            initial: [
              {
                field: "updatedAt",
                order: "desc"
              }
            ]
          },
        pagination: {
            pageSize: 10
          }
    });
    
    const { mutate } = useUpdate();
    const checkUrlChange = useCallback((id: string) => {
        mutate(
                {
                    resource: "review",
                    values: {
                        status: 10
                    },
                    id,
                },
            );
    }, [mutate])
    const closeUrlChange = useCallback((id: string) => {
        mutate(
            {
                resource: "review",
                values: {
                    status: 11
                },
                id,
            },
        );
    }, [mutate])
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [result, setResult] = useState("");
    const showPhotoFun = (messages: any, results: string) => {
        setIsOpen(true);
        setMessage(messages);
        setResult(results);
    }
    const handleClose = () => {
        setIsOpen(false);
    }
    const columns = React.useMemo<GridColumns<any>>(
        () => [
            {
                field: "name",
                headerName: "Name",
                minWidth: 250,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row?.metadata?.fileOriginalName) {
                        return row.metadata.fileOriginalName;
                    } else {
                        return "--";
                    }
                },
            },
            {
                field: "status",
                headerName: "Status",
                minWidth: 100,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    return ReviewStatus.fromValue(row.status)?.name;
                },
            },
            {
                field: "user",
                headerName: "User",
                minWidth: 80,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row && row.messages && row?.messages[0]?.userName) {
                        return row?.messages[0]?.userName;
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "url",
                headerName: "Url",
                minWidth: 80,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row?.metadata && row?.metadata?.fileMimeType === undefined) {
                        return <a href={`https://${row?.uri}`} target="_blank" rel="noopener noreferrer"><LinkIcon/></a>
                    } else if (row?.metadata?.fileMimeType.endsWith("plain") || row?.metadata?.fileMimeType.endsWith("pdf") || row?.metadata?.fileMimeType.endsWith("msword")) {
                        return <a href={row?.uri} target="_blank" rel="noopener noreferrer"><LinkIcon/></a>
                    } else {
                        return <img src={row?.uri} alt="" style={{width:"90px"}} onClick={() => showPhotoFun(row?.uri, row?.metadata?.rekognitionResult)}/>
                    }
                },
            },
            {
                field: "createdAt",
                headerName: "CreatedAt",
                minWidth: 160,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.createdAt) {
                        return new Date(row.createdAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "updatedAt",
                headerName: "UpdatedAt",
                minWidth: 160,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.updatedAt) {
                        return new Date(row.updatedAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "actions",
                headerName: "Actions",
                minWidth: 250,
                align: "left",
                headerAlign: "center",
                filterable: false,
                hideable: false,
                sortable: false,
                renderCell: function render({ row }) {
                    return (
                        <>  {
                                !(row?.metadata.fileMimeType === undefined || row?.metadata?.fileMimeType.endsWith("plain") || row?.metadata?.fileMimeType.endsWith("pdf") || row?.metadata?.fileMimeType.endsWith("msword" )) ? 
                                    <Button variant="contained" size="small" style={{marginLeft:"10px"}}
                                        onClick={() => showPhotoFun(row?.uri, row?.metadata?.rekognitionResult)}
                                    >
                                        SHOW
                                    </Button> : null
                            }
                            <Button variant="contained" size="small" style={{marginLeft:"10px"}} onClick={() => checkUrlChange(row.id)}>
                                <CheckSharpIcon/>
                            </Button>
                            <Button variant="contained" size="small" style={{marginLeft:"10px"}} onClick={() => closeUrlChange(row.id)}>
                                <CloseIcon/>
                            </Button>
                        </>
                    );
                },
            },
        ],
        [checkUrlChange, closeUrlChange],
    );

    // search parts
    const [status, setStatus] = useState<any>("1");
    const handleFilter = (
    ) => {
        setCurrent(1);
        setPageSize(10);
        let searchArr: {field: string; value: string; operator: string}[] = [];
        if (status) {
            searchArr.push({
                field: "status",
                value: `${status}`,
                operator: "eq",
            });
        }
        setFilters(searchArr as any);
    };

    const clearFun = () => {
        setStatus("1");
    }
    return (
        <List>
            <FormControlLabel
                label=""
                style={{width: "100%"}}
                control={
                    <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", marginBottom: "12px"}}>
                        <div style={{width: "90%", paddingBottom: "3px"}}>
                            <FormControl style={{width: "100%"}}>
                                <InputLabel id="status">Status : </InputLabel>
                                <Select
                                    labelId="status"
                                    value={status as any}
                                    label="Status"
                                    variant="standard"
                                    onChange={(event: SelectChangeEvent) => {
                                        setStatus(event.target.value as any);
                                    }}
                                >
                                    {
                                        Object.values(ReviewStatus)[0].map((item: any, index: any) => {
                                            return index !== 0 && <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{width: "60px", marginBottom: "7px"}}>
                            <ClearOutlinedIcon onClick={clearFun}/>
                            <SearchIcon onClick={handleFilter}/>
                        </div>
                    </div>
                }
            />
                <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
            {
                isOpen? <ShowPhoto isOpen={isOpen} handleClose={handleClose} message={message} result={result}/> : null
            }
        </List>
    );
};
